import {
    HubConnection,
    HubConnectionBuilder,
    HubConnectionState,
    HttpTransportType,
} from "@microsoft/signalr";
import { API_URL, getCurrentLng, getHeaders, ApiMessage, toApiMessage, APIResponse, refreshSession, getSession, ACCOUNTANT_API_URL, APIRequest, TRADING_API_URL } from './Api';


/** Module‑level variable that holds the single instance */
let feedConnection: any = null;

/**
 * Returns a started HubConnection.
 * If a connection already exists and is still connected, it is reused (singleton).
 * Otherwise a new connection is built and started.
 */
export const getFeedConnection = async (): Promise<HubConnection | null> => {
    // Re‑use the existing live connection

    if (
        feedConnection &&
        feedConnection.state === HubConnectionState.Connected
    ) {
        return feedConnection;
    }


    // Helper that actually builds & starts the connection
    const buildConnection = async (): Promise<HubConnection | null> => {
        try {
            const connection = new HubConnectionBuilder()
                .withUrl(`${TRADING_API_URL}/feed`, {
                    transport: HttpTransportType.WebSockets,
                    accessTokenFactory: () =>
                        getSession().accesstoken?.token?.value ?? "",
                })
                .withAutomaticReconnect()
                .build();

            await connection.start();

            return connection;
        } catch (err: any) {
            // Token expired? Try once after refreshing the session
            if (err.message?.includes("Status code '401'")) {
                const refreshed = await refreshSession();
                if (refreshed) {
                    return await buildConnection();
                }
            }
            return null;
            // Re‑throw so callers can handle/reject as they wish
        }
    };

    feedConnection = await buildConnection();

    return feedConnection;
};
export const terminateFeedConnection = async (): Promise<void> => {
    // Re‑use the existing live connection
    if (feedConnection == null || feedConnection == undefined) {
        return;
    }
    feedConnection.off()
    await feedConnection.stop();

    feedConnection = null;

    // Helper that actually builds & starts the connection


};
